<template>
  <div class="gmf-progress-bar">
    <div class="gmf-progress-bar-fill" :style="{ width }"/>
  </div>
</template>

<style>
.gmf-progress-bar {
  width: 100%;
  padding: var(--gmf-p-2);
  /*margin: 0 calc(0px - var(--gmf-p-2));*/
  border-radius: var(--gmf-rounding);
  background: var(--gmf-col-lightgray);
}
.gmf-progress-bar-fill {
  height: 16px;
  border-radius: var(--gmf-rounding);
  background: var(--gmf-brand-color);
}
</style>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
    min: {
      default: 0,
      type: Number,
      required: false,
    },
    max: {
      default: 1,
      type: Number,
      required: false,
    },
  },
  computed: {
    width () {
      const v = this.value - this.min;
      const range = this.max - this.min;
      return (Math.min(v / range, 1) * 100) + '%';
    },
  },
};
</script>
